import React from "react";
import { Box, Text, Stack, Group, Tooltip, Card, Divider, SegmentedControl } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { StandardRoomDiff } from "./StandardRoomDiff";
import { selectStandardRoomPanel } from "./standardRoomPanelSelectors";
import { changeStandardRoomDisciplineThunk } from "../validationPanelThunks";

export const DrofusStandardRoomDiffAllDisciplines: React.FC = () => {
  const dispatch = useAppDispatch();
  const { disciplines, discipline, matchRatePct, validatedAt, disciplineOptions, validatedDate } =
    useAppSelector(selectStandardRoomPanel);

  return (
    <Card
      withBorder
      radius="md"
      w="100%"
      h="100%"
      style={{ display: "flex", flexDirection: "column", minHeight: 0, overflowY: "auto" }}
    >
      {/* Header/top - fixed height */}
      <Stack gap="xs" align="flex-start" style={{ flex: "0 0 auto" }}>
        {disciplines.length === 0 && (
          <Text>Ingen tilgjengelige disipliner for standardromvalidering</Text>
        )}

        {disciplines.length > 0 && (
          <Box w="100%">
            <Group justify="space-between" align="center">
              {
                <SegmentedControl
                  value={discipline}
                  onChange={(value) => dispatch(changeStandardRoomDisciplineThunk(value))}
                  data={disciplineOptions}
                  radius="xl"
                  size="sm"
                  color="blue"
                  transitionDuration={120}
                />
              }
              {matchRatePct != null && validatedAt != null && (
                <Stack gap={0} align="flex-end" style={{ minWidth: 0 }}>
                  <Group gap="xs">
                    <Text size="xs" c="dimmed">
                      Treffsikkerhet
                    </Text>
                    <Text size="xs" fw={600}>
                      {matchRatePct.toFixed(1)} %
                    </Text>
                  </Group>

                  <Tooltip label={validatedAt} position="bottom-end" withArrow>
                    <Text size="xs" c="dimmed">
                      Sist validert {validatedDate}
                    </Text>
                  </Tooltip>
                </Stack>
              )}
            </Group>
          </Box>
        )}
      </Stack>

      <Divider my="xs" />

      {discipline != null && <StandardRoomDiff discipline={discipline} />}
    </Card>
  );
};
